import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdEmail } from 'react-icons/md'; // Material Design email icon


function TranslatorTerms() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };
    
    return (
        <div className="pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
            <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                <MdArrowBack size={25} className="md:hidden" onClick={() => {
                    navigate('/mobile/translator/settings')
                }} />
                <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                    navigate('/mobile/translator/settings')
                }} />
                <p className="text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t157')}</p>
            </div>

            <div className='flex flex-col justify-center items-start h-full w-full pl-[10px] pr-[2px] md:pl-[40px] md:pr-[20px] lg:pl-[110px] lg:pr-[20px] xl:pl-[50px] xl:pr-[20px] pb-[100px] md:pb-[20px]'>
                <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t363')}</p>
                <p className='mt-[5px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t364')}</p>
                <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t365')}</p>
                <p className='mt-[5px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t366')}</p>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                    <li>{t('t367')}</li>
                    <li>{t('t368')}</li>
                    <li>{t('t369')}</li>
                </ul>
                <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t370')}</p>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                    <li>{t('t371')}</li>
                    <li>{t('t372')}</li>
                    <li>{t('t373')}</li>
                </ul>
                <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t374')}</p>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                    <li>{t('t375')}</li>
                    <li>{t('t376')}</li>
                    <li>{t('t377')}</li>
                </ul>
                <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t378')}</p>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                    <li>{t('t379')}</li>
                    <li>{t('t380')}</li>
                </ul>
            </div>
        </div>
    );
}

export default TranslatorTerms;



